<template>
  <div class="elenco-documenti">

    <transition name="fade">
      <ricerca v-show="showSearchPanel"
              :prefixApp="prefixApp"
              @closeRicerca="closeSearch"
              @cerca="cerca"
              @loadingOff="setLoading(false)">
      </ricerca>
    </transition>

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="col-6 no-padding icon-search">
        <el-button @click="openSearch">
          <el-tooltip class="item" effect="dark" :content="$t('elencoDoc.cerca')" placement="top-start">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-tooltip>
        </el-button>
      </div>
      <div class="ordine col-12">
        <div class="magazzino col-24">{{getStabilimento()}}</div>
        <div class="numero col-24">{{getOrdNum(ordine.numOrd)}}</div>
      </div>
      <div class="fornitore col-6 no-padding">
        <span>
        {{fornitore}} - {{desFornitore}}
        </span>
      </div>
    </div>

    <el-tabs
        v-model="tabActive"
        type="card"
        class="col-24 custom-tabs"
        @tab-click="tabClick"
      >
        <el-tab-pane
          :key="($t('elencoDoc.ditta') + ' ' + ditta_ragg_pag.counterWarning)"
        >
          <div style="width: 250px" slot="label">
            <div class="col-xs-24 no-padding counter-nuovi">
              <el-badge
                :value="ditta_ragg_pag.counterWarning"
                class="item"
                :hidden="(ditta_ragg_pag.counterWarning <= 0)"
              >{{ $t('elencoDoc.ditta') }}</el-badge>
            </div>
            <div class="col-xs-24 no-padding barra"></div>
          </div>

          <!-- Tabella Raggruppamenti DITTA-->
          <div class="col-24 no-padding" v-show="ditta_vista === 'raggruppamenti'">
              <el-table
              :data="ditta_ragg"
              class="col-xs-24 custom-table table-doc no-padding"
              v-loading="loading_ditta_ragg"
            >
              <el-table-column header-align="center" align="center" width="30">
                <template slot-scope="scope" slot="header">
                  <el-popover placement="top" trigger="click" :key="scope.$index">
                    <div>
                      <div>
                        <icon :name="getStatoIcon('0')" class="status-saved" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.0') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('1')" class="status-send" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.1') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.2') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('3')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.3') }}</span>
                      </div>
                    </div>
                    <span slot="reference">
                      <icon class="pointer" name="riv-help" scale="1"></icon>
                    </span>
                  </el-popover>
                </template>

                <template slot-scope="scope">
                  <div class="data-wrapper">
                    <icon :name="getStatoIcon(scope.row.statoTipo)" scale="1"></icon>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="codTipo" :label="$t('elencoDoc.tipo')" width="120" class-name="tipoDoc"></el-table-column>
              <el-table-column prop="desTipo" :label="$t('elencoDoc.desc')" min-width="200"></el-table-column>
              <el-table-column prop="numOrd" :label="$t('elencoDoc.numOrd')" width="110"></el-table-column>
              <el-table-column prop="desSoc" :label="$t('elencoDoc.soc')" max-width="200"></el-table-column>
              <el-table-column prop="desMag" :label="$t('elencoDoc.sta')" max-width="200"></el-table-column>
              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" @click="openTipologiaDitta(scope.row)">
                    <icon v-if="scope.row.docRiva === 'Y'" name="riv-docCheck" scale="1.3"></icon>
                    <icon v-else name="riv-docUpload" scale="1.3"></icon>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              v-if="(ditta_ragg_pag.nrPages > 1)"
              :current-page="ditta_ragg_pag.currentPage"
              background
              class="custom-pagination"
              layout="prev, pager, next"
              :total="ditta_ragg_pag.nrItems"
              :page-size="ditta_ragg_pag.pag_for"
              @current-change="changePageDittaRagg"
            ></el-pagination>
          </div>

          <!-- Tabella Documenti Ditta-->
          <div class="col-24 no-padding" v-show="ditta_vista === 'docsGenerici'">
            <div class="row row-custom no-padding">
              <div class="return-tab">
                <icon
                  name="riv-arrow2"
                  scale="1.2"
                  flip="horizontal"
                  @click.native="returnDittaRagg()"
                  class="pointer"
                ></icon>
                <span>{{ditta_raggruppamento.codTipo}} -</span>
                <span class="capitalize">{{ditta_raggruppamento.desTipo}}</span>
              </div>
              <div class="add" v-if="ditta_raggruppamento.docRiva !== 'Y'">
                <el-tooltip class="item" effect="dark" :content="$t('elencoDoc.uploadDoc')" placement="top-start">
                  <icon name="riv-add_2" scale="2.5" flip="horizontal" @click.native="uploadDocumentoDitta()" class="pointer"></icon>
                </el-tooltip>
              </div>
            </div>

            <el-table
              :data="ditta_docs"
              class="col-xs-24 custom-table table-doc no-padding"
              v-loading="loading_ditta_docs"
            >
              <el-table-column header-align="center" align="center" width="70">
                <template slot-scope="scope" slot="header">
                  <el-popover placement="top" trigger="click" :key="scope.toString()">
                    <div>
                      <div>
                        <icon :name="getStatoIcon('1')" class="status-send" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.1') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.2') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('3')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.3') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('4')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.4') }}</span>
                      </div>
                    </div>
                    <span slot="reference">
                      <icon class="pointer" name="riv-help" scale="1"></icon>
                    </span>
                  </el-popover>
                </template>

                <template slot-scope="scope">
                  <div class="data-wrapper">
                    <icon :name="getStatoIcon(scope.row.statoDoc)" scale="1"></icon>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="idDoc" :label="$t('elencoDoc.idDoc')" width="140"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtIns')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                  >{{ scope.row.dataIns === '' ? '' : moment(scope.row.dataIns, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtDoc')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                  >{{ scope.row.dataDoc === '' ? '' : moment(scope.row.dataDoc, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtSca')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                    :class="{'scaduto': scope.row.statoDoc === '4'}"
                  >{{ scope.row.dataSca === '' ? '' : moment(scope.row.dataSca, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtApp')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                  >{{ scope.row.dataApp === '' ? '' : moment(scope.row.dataApp, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="approvatore"
                :label="$t('elencoDoc.app')"
                min-width="200"
              ></el-table-column>

              <el-table-column v-if="ditta_raggruppamento.docRiva === 'Y'"
                header-align="center"
                align="center"
                :label="$t('elencoDoc.pv')"
                width="50"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper icon-center"  v-if="scope.row.docRiva === 'Y'">
                    <icon v-if="scope.row.presaVis === 'N'" name="riv-pv_0" scale="1.2"></icon>
                    <icon v-else name="riv-pv_1" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" v-if="scope.row.statoDoc === '3'">
                    <el-tooltip placement="left">
                      <div slot="content" v-html="scope.row.noteRifiuto.split('\\n').join('\n')" style="white-space: pre-line"></div>
                      <icon name="riv-addnotes" scale="1.2"></icon>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" @click="deleteDocDitta(scope.row)" v-if="scope.row.statoDoc === '1'">
                    <icon name="riv-delete2" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" @click="openDocumento(scope.row)">
                    <icon name="riv-searchPas" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" @click="getDocumento(scope.row)">
                    <icon name="riv-downloadPas" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              v-if="(ditta_docs_pag.nrPages > 1)"
              :current-page="ditta_docs_pag.currentPage"
              background
              class="custom-pagination"
              layout="prev, pager, next"
              :total="ditta_docs_pag.nrItems"
              :page-size="ditta_docs_pag.pag_for"
              @current-change="changePageDittaDocs"
            ></el-pagination>
          </div>

        </el-tab-pane>

        <el-tab-pane
          :key="($t('elencoDoc.dipendente') + ' ' + dipendenti_pag.counterWarning)"
        >
          <div style="width: 250px" slot="label">
            <div class="col-xs-24 no-padding counter-nuovi">
              <el-badge
                :value="dipendenti_pag.counterWarning"
                class="item"
                :hidden="(dipendenti_pag.counterWarning <= 0)"
              >{{ $t('elencoDoc.dipendente') }}</el-badge>
            </div>
            <div class="col-xs-24 no-padding barra"></div>
          </div>

          <!-- Tabella DIPENDENTI-->
          <div class="col-24 no-padding" v-show="dip_vista === 'raggruppamenti'">
            <el-table :data="dipendenti" 
              sort-change="sortChange" 
              class="custom-table table-doc no-padding" 
              @expand-change="goToDettaglioDip"
              v-loading="loading_dip">

              <el-table-column header-align="center" align="center" width="30">
                <template slot-scope="scope" slot="header">
                  <el-popover placement="top" trigger="click" :key="scope.toString()">
                    <div>
                      <div>
                        <icon :name="getStatoIcon('0')" class="status-saved" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.0') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('1')" class="status-send" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.1') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.2') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('3')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.raggStatus.3') }}</span>
                      </div>
                    </div>
                    <span slot="reference">
                      <icon class="pointer" name="riv-help" scale="1"></icon>
                    </span>
                  </el-popover>
                </template>

                <template slot-scope="scope">
                  <div class="data-wrapper">
                    <icon :name="getStatoIcon(scope.row.statoDip)" scale="1"></icon>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                :label="$t('elencoDoc.dipendente')"
                width="200"
                prop="dipendente"
                >

                <template slot-scope="scope">
                  <div class="cell no-padding">
                    {{ scope.row.codDip }}  <span class="bold">{{ scope.row.cognome }}  {{ scope.row.nome }}</span>
                  </div>
                </template>

              </el-table-column>
              <el-table-column header-align="center" align="center"
                :label="$t('elencoDoc.dataNascita')"
                width="100">

                <template slot-scope="scope">
                  <div class="cell no-padding">
                    {{ scope.row.dataNascita === '' ? '' : moment(scope.row.dataNascita, 'YYYYMMDD').format('DD/MM/YYYY') }}
                  </div>
                </template>

              </el-table-column>
              <el-table-column header-align="center" align="center"
                prop="luogoNascita"
                :label="$t('elencoDoc.luogoNascita')"
                min-width="150">
              </el-table-column>
              <el-table-column header-align="center" align="center"
                prop="sesso"
                :label="$t('elencoDoc.sesso')"
                min-width="50">
              </el-table-column>
              <el-table-column header-align="center" align="center"
                :label="$t('elencoDoc.dataAssunzione')"
                width="100"
                prop="dataAssunzione">

                <template slot-scope="scope">
                  <div class="cell no-padding">
                    {{ scope.row.dataAssunzione === '' ? '' : moment(scope.row.dataAssunzione, 'YYYYMMDD').format('DD/MM/YYYY') }}
                  </div>
                </template>

              </el-table-column>
              <el-table-column header-align="center" align="center"
                :label="$t('elencoDoc.dataCessazione')"
                width="100">

                <template slot-scope="scope">
                  <div class="cell no-padding">
                    {{ scope.row.dataCessazione === '' ? '' : moment(scope.row.dataCessazione, 'YYYYMMDD').format('DD/MM/YYYY') }}
                  </div>
                </template>

              </el-table-column>
              <el-table-column 
                prop="desMansione"
                :label="$t('elencoDoc.mansione')"
                min-width="150"
                header-align="center" align="center">
              </el-table-column>
              <el-table-column
                :label="$t('elencoDoc.tipoRapp')"
                min-width="200"
                prop="tipoRapp"
                header-align="center" align="center">

                <template slot-scope="scope">
                  <div class="cell no-padding">
                    {{ scope.row.desTipoRap }}
                  </div>
                </template>

              </el-table-column>

              <!-- Gestione Expand Dipendenti -->
              <el-table-column type="expand">
                <template class="exp" slot-scope="props">
                  <el-table
                    :data="dipendenti_expand"
                    :key="props.row.numOrd"
                    v-loading="loading_dipendenti_expand"
                    :show-header="false"
                    class="custom-table"
                    :row-class-name="setClassRow"
                  >
                    <el-table-column header-align="center" align="center" width="70">
                      <template slot-scope="scope">
                        <div class="data-wrapper">
                          <icon :name="getStatoIcon(scope.row.statoTipo)" scale="1"></icon>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="codTipo"
                      :label="$t('elencoDoc.tipo')"
                      width="120"
                      class-name="tipoDoc"
                    >
                      <template slot-scope="scope">
                        <div class="name-wrapper">
                          <span>{{scope.row.codTipo}}</span>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="desTipo"
                      :label="$t('elencoDoc.desc')"
                      min-width="200"
                    >
                      <template slot-scope="scope">
                        <div class="name-wrapper">
                          <span>{{scope.row.desTipo}}</span>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="numOrd"
                      :label="$t('elencoDoc.numOrd')"
                      width="110"
                    >
                      <template slot-scope="scope">
                        <div class="name-wrapper">
                          <span>{{scope.row.numOrd}}</span>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="desMag"
                      :label="$t('elencoDoc.sta')"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <div class="name-wrapper">
                          <span>{{scope.row.desMag}}</span>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column width="50">
                      <template slot-scope="scope">
                        <div class="name-wrapper pointer action" @click="openTipologiaDip(scope.row)">
                          <icon v-if="scope.row.docRiva === 'Y'" name="riv-docCheck" scale="1.3"></icon>
                          <icon v-else name="riv-docUpload" scale="1.3"></icon>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>

            </el-table>

            <el-pagination v-if="(dipendenti_pag.nrPages > 1)" :current-page="dipendenti_pag.currentPage" class="custom-pagination"
                          background
                          layout="prev, pager, next"
                          :total="dipendenti_pag.nrItems"
                          :page-size="dipendenti_pag.pag_for"
                          @current-change="changePageDip">
            </el-pagination>
          </div>

          <!-- Tabella Documenti Dipendenti-->
          <div class="col-24 no-padding" v-show="dip_vista === 'docsGenerici'">
            <div class="row row-custom no-padding">
              <div class="return-tab">
                <icon
                  name="riv-arrow2"
                  scale="1.2"
                  flip="horizontal"
                  @click.native="returnDipRagg()"
                  class="pointer"
                ></icon>
                <span>{{dip_raggruppamento.codTipo}} -</span>
                <span class="capitalize">{{dip_raggruppamento.desTipo}}</span>
              </div>
              <div class="add" v-if="dip_raggruppamento.docRiva !== 'Y'">
                <el-tooltip class="item" effect="dark" :content="$t('elencoDoc.uploadDoc')" placement="top-start">
                   <icon name="riv-add_2" scale="2.5" flip="horizontal" @click.native="uploadDocumentoDip()" class="pointer" ></icon>
                </el-tooltip>
              </div>
            </div>

            <el-table
              :data="dip_docs"
              class="col-xs-24 custom-table table-doc no-padding"
              v-loading="loading_dip_docs"
            >
              <el-table-column header-align="center" align="center" width="70">
                <template slot-scope="scope" slot="header">
                  <el-popover placement="top" trigger="click" :key="scope.$index">
                    <div>
                      <div>
                        <icon :name="getStatoIcon('1')" class="status-send" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.1') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.2') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('3')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.3') }}</span>
                      </div>
                      <div>
                        <icon :name="getStatoIcon('4')" class="status-rejected" scale="1"></icon>
                        <span>{{ $t('elencoDoc.docStatus.4') }}</span>
                      </div>
                    </div>
                    <span slot="reference">
                      <icon class="pointer" name="riv-help" scale="1"></icon>
                    </span>
                  </el-popover>
                </template>

                <template slot-scope="scope">
                  <div class="data-wrapper">
                    <icon :name="getStatoIcon(scope.row.statoDoc)" scale="1"></icon>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="idDoc" :label="$t('elencoDoc.idDoc')" width="140"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtIns')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                  >{{ scope.row.dataIns === '' ? '' : moment(scope.row.dataIns, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtDoc')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                  >{{ scope.row.dataDoc === '' ? '' : moment(scope.row.dataDoc, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtSca')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                    :class="{'scaduto': scope.row.statoDoc === '4'}"
                  >{{ scope.row.dataSca === '' ? '' : moment(scope.row.dataSca, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                :label="$t('elencoDoc.dtApp')"
                width="140"
              >
                <template slot-scope="scope">
                  <div
                    class="cell no-padding"
                  >{{ scope.row.dataApp === '' ? '' : moment(scope.row.dataApp, 'YYYYMMDD').format('DD/MM/YYYY') }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="approvatore"
                :label="$t('elencoDoc.app')"
                min-width="200"
              ></el-table-column>

              <el-table-column v-if="dip_raggruppamento.docRiva === 'Y'"
                header-align="center"
                align="center"
                :label="$t('elencoDoc.pv')"
                width="50"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper icon-center"  v-if="scope.row.docRiva === 'Y'">
                    <icon v-if="scope.row.presaVis === 'N'" name="riv-pv_0" scale="1.2"></icon>
                    <icon v-else name="riv-pv_1" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" @click="deleteDocDip(scope.row)" v-if="scope.row.statoDoc === '1'">
                    <icon name="riv-delete2" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" @click="openDocumento(scope.row)">
                    <icon name="riv-searchPas" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="name-wrapper pointer action" @click="getDocumento(scope.row)">
                    <icon name="riv-downloadPas" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              v-if="(dip_docs_pag.nrPages > 1)"
              :current-page="dip_docs_pag.currentPage"
              background
              class="custom-pagination"
              layout="prev, pager, next"
              :total="dip_docs_pag.nrItems"
              :page-size="dip_docs_pag.pag_for"
              @current-change="changePageDipDocs"
            ></el-pagination>
          </div>
          
        </el-tab-pane>
      </el-tabs>


  </div>
</template>

<script>
  import Ricerca from './Ricerca.vue'
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    name: 'ElencoDocumenti',
    components: {Ricerca},
    i18n: {
      messages: {
        it_IT: {
          elencoDoc: {
            cerca: 'Cerca',
            ditta: 'ditta',
            dipendente: 'Dipendente',
            tipo: 'Tipo',
            desc: 'Descrizione',
            numOrd: 'N. Ordine',
            ordine: 'Ordine N. {num}',
            soc: 'Società',
            sta: 'Stabilimento',
            idDoc: 'Id Documento',
            dtIns: 'Inserito',
            dtDoc: 'Emesso',
            dtSca: 'Scadenza',
            dtApp: 'Verificato il',
            app: 'Verificato da',
            dataNascita: 'Nato il',
            luogoNascita: 'Nato a',
            sesso: 'Sesso',
            dataAssunzione: 'Assunto il',
            dataCessazione: 'Cessazione il',
            mansione: 'Mansione',
            tipoRapp: 'Tipo Rapporto',
            pv: 'PV',
            raggStatus: {
              0: 'Nessun Documento Presente',
              1: 'Presenza di almeno un documento da approvare',
              2: 'Tutti i documenti sono in regola',
              3: 'Presenza di almeno un documento non in regola'
            },
            docStatus: {
              1: 'Documento in approvazione',
              2: 'Documenti in regola',
              3: 'Documento Rifiutato',
              4: 'Documento Scaduto'
            },
            uploadDoc: 'Upload Documento',
            deleteOK: 'Documento cancellato correttamente'
          }
        },
        fr_FR: {
          elencoDoc: {
            cerca: 'Rechercher',
            ditta: 'Entreprise',
            dipendente: 'Employé',
            tipo: 'Type',
            desc: 'Description',
            numOrd: 'N. Commande',
            ordine: 'Commande N. {num}',
            soc: 'Société',
            sta: 'Établissement',
            idDoc: 'ID du document',
            dtIns: 'Soumis',
            dtDoc: 'Publié',
            dtSca: 'Date limite',
            dtApp: 'Vérifié le',
            app: 'Vérifié par',
            dataNascita: 'Né le',
            luogoNascita: 'Né à',
            sesso: 'Sexe',
            dataAssunzione: 'Embauché le',
            dataCessazione: 'Cessation le',
            mansione: 'Tâche',
            tipoRapp: 'Type de rapport',
            pv: 'PV',
            raggStatus: {
              0: 'Aucun document présent',
              1: "Présence d'au moins un document à approuver",
              2: 'Tous les documents sont en règle',
              3: "Présence d'au moins un document non conforme"
            },
            docStatus: {
              1: "Document en cours d'approbation",
              2: 'Document en ordre',
              3: 'Document rejeté',
              4: 'Document expiré'
            },
            uploadDoc: 'Téléchargez un nouveau document',
            deleteOK: 'Document supprimé avec succès'
          }
        },
        es_ES: {
          elencoDoc: {
            cerca: 'Buscar',
            ditta: 'Firma',
            dipendente: 'Empleado',
            tipo: 'Tipo',
            desc: 'Descripción',
            numOrd: 'N. Orden',
            ordine: 'Orden N. {num}',
            soc: 'Sociedad',
            sta: 'Establecimiento',
            idDoc: 'ID del documento',
            dtIns: 'Presentado',
            dtDoc: 'Emitido',
            dtSca: 'Fecha límite',
            dtApp: 'Cambiado el',
            app: 'Cambiado en',
            dataNascita: 'Nacido el',
            luogoNascita: 'Nacido en',
            sesso: 'Sexo',
            dataAssunzione: 'ontratado el',
            dataCessazione: 'Cesado el',
            mansione: 'Tarea',
            tipoRapp: 'Tipo de relacion',
            pv: 'PV',
            raggStatus: {
              0: 'No hay documentos presentes',
              1: 'Presencia de al menos un documento para ser aprobado',
              2: 'Todos los documentos están en orden',
              3: 'Presencia de al menos un documento no en orden'
            },
            docStatus: {
              1: 'Documento bajo aprobación',
              2: 'Documentos en orden',
              3: 'Documento rechazado',
              4: 'Documento caducado'
            },
            uploadDoc: 'Subir nuevo documento',
            deleteOK: 'Documento eliminado con éxito'
          }
        },
        de_DE: {
          elencoDoc: {
            cerca: 'Suche',
            ditta: 'Feste',
            dipendente: 'Mitarbeiter',
            tipo: 'Art',
            desc: 'Beschreibung',
            numOrd: 'N. Auftrag',
            ordine: 'Auftrag N. {num}',
            soc: 'Gesellschaft',
            sta: 'Einrichtung',
            idDoc: 'Dokument Identifikation',
            dtIns: 'Eingereicht',
            dtDoc: 'Ausgegeben',
            dtSca: 'Frist',
            dtApp: 'Geändert am',
            app: 'Geprüft von',
            dataNascita: 'Geboren am',
            luogoNascita: 'Geboren in',
            sesso: 'Sex',
            dataAssunzione: 'Angestellt am',
            dataCessazione: 'Aufgehört am',
            mansione: 'Aufgabe',
            tipoRapp: 'Arbeitsbeziehungstyp',
            pv: 'PV',
            raggStatus: {
              0: 'Keine Dokumente vorhanden',
              1: 'Vorhandensein mindestens eines zu genehmigenden Dokuments',
              2: 'Alle Dokumente sind in Ordnung',
              3: 'Vorhandensein mindestens eines Dokuments nicht in Ordnung'
            },
            docStatus: {
              1: 'Dokument in Genehmigung',
              2: 'Dokumente in Ordnung',
              3: 'Abgelehntes Dokument',
              4: 'Abgelaufenes Dokument'
            },
            uploadDoc: 'Neues Dokument hochladen',
            deleteOK: 'Dokument erfolgreich gelöscht'
          }
        },
        en_GB: {
          elencoDoc: {
            cerca: 'Search',
            ditta: 'Firm',
            dipendente: 'Employee',
            tipo: 'Type',
            desc: 'Description',
            numOrd: 'N. Order',
            ordine: 'Order N. {num}',
            soc: 'Society',
            sta: 'Establishment',
            idDoc: 'Document ID',
            dtIns: 'Submitted',
            dtDoc: 'Issued',
            dtSca: 'Deadline',
            dtApp: 'Verified on',
            app: 'Verified by',
            dataNascita: 'Born on',
            luogoNascita: 'Born in',
            sesso: 'Sex',
            dataAssunzione: 'Hired on',
            dataCessazione: 'Ceased on',
            mansione: 'Task',
            tipoRapp: 'Relationship type',
            pv: 'PV',
            raggStatus: {
              0: 'No Documents Present',
              1: 'Presence of at least one document to be approved',
              2: 'All documents are in order',
              3: 'Presence of at least one document not in order'
            },
            docStatus: {
              1: 'Document under approval',
              2: 'Documents in order',
              3: 'Rejected document',
              4: 'Expired Document'
            },
            uploadDoc: 'Upload New Document',
            deleteOK: 'Document successfully deletede'
          }
        }
      }
    },
    props: {
      prefixApp: {
        type: String
      }
    },
    data () {
      return {
        moment: moment,
        codLang: sessionStorage.getItem('codLang'),
        codForn: '',
        country: '',
        showSearchPanel: false,
        desFornitore: '',
        fornitore: '',
        tabActive: '0',
        ditta_vista: 'raggruppamenti',
        dip_vista: 'raggruppamenti',
        ordine: {},
        // DITTA - RAGGRUPPAMENTI
        loading_ditta_ragg: false,
        ditta_ragg: [],
        ditta_ragg_pag: {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        },
        ditta_raggruppamento: {},
        // DITTA - DOCS
        loading_ditta_docs: false,
        ditta_docs: [],
        ditta_docs_pag: {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        },
        // DIPENDENTI
        dipendenti: [],
        loading_dip: false,
        dipendenti_pag: {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        },
        // DIPENDENTI EXPAND
        codDip: '',
        desDip: '',
        dipendenti_expand: [],
        loading_dipendenti_expand: false,
        // DIPENDENTI - DOCS
        dip_raggruppamento: {},
        loading_dip_docs: false,
        dip_docs: [],
        dip_docs_pag: {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        }
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'ditta_ragg', [])
        this.$set(this.ditta_ragg_pag, 'nrPages', 0)
        this.$set(this.ditta_ragg_pag, 'nrItems', 0)
        this.$set(this.ditta_ragg_pag, 'currentPage', 1)
        this.$set(this, 'dipendenti', [])
        this.$set(this.dipendenti_pag, 'nrPages', 0)
        this.$set(this.dipendenti_pag, 'nrItems', 0)
        this.$set(this.dipendenti_pag, 'currentPage', 1)
      })
      bus.$on('ACCSTA_ChangeCountryFromDsh', () => {
        this.$set(this, 'ditta_ragg', [])
        this.$set(this.ditta_ragg_pag, 'nrPages', 0)
        this.$set(this.ditta_ragg_pag, 'nrItems', 0)
        this.$set(this.ditta_ragg_pag, 'currentPage', 1)
        this.$set(this, 'dipendenti', [])
        this.$set(this.dipendenti_pag, 'nrPages', 0)
        this.$set(this.dipendenti_pag, 'nrItems', 0)
        this.$set(this.dipendenti_pag, 'currentPage', 1)
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      init: function () {
        this.$set(this, 'country', this.$store.state.DOC_Ricerca.country)
        this.$set(this, 'codForn', this.$store.state.DOC_Ricerca.codForn)
        this.$set(this, 'fornitore', this.$store.state.DOC_Ricerca.codForn)
        this.$set(this, 'desFornitore', this.$store.state.DOC_Ricerca.codForn)
        this.$store.dispatch('ifObject', 'DOC_Ricerca').then((ifRicerca) => {
          if (ifRicerca) {
            this.ricerca()
          }
        })
      },
      resetDati: function () {
        this.$set(this, 'codForn', '')
        this.$set(this, 'country', '')
        this.$set(this, 'showSearchPanel', false)
        this.$set(this, 'desFornitore', '')
        this.$set(this, 'fornitore', '')
        this.$set(this, 'tabActive', '0')
        this.$set(this, 'ditta_vista', 'raggruppamenti')
        this.$set(this, 'dip_vista', 'raggruppamenti')
        this.$set(this, 'ordine', {})
        // DITTA - RAGGRUPPAMENTI
        this.$set(this, 'loading_ditta_ragg', false)
        this.$set(this, 'ditta_ragg', [])
        this.$set(this, 'ditta_ragg_pag', {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        })
        this.$set(this, 'ditta_raggruppamento', {})
        // DITTA - DOCS
        this.$set(this, 'loading_ditta_docs', false)
        this.$set(this, 'ditta_docs', [])
        this.$set(this, 'ditta_docs_pag', {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        })
        // DIPENDENTI
        this.$set(this, 'dipendenti', [])
        this.$set(this, 'loading_dip', false)
        this.$set(this, 'dipendenti_pag', {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        })
        // DIPENDENTI - EXPAND
        this.$set(this, 'codDip', '')
        this.$set(this, 'desDip', '')
        this.$set(this, 'dipendenti_expand', [])
        this.$set(this, 'loading_dipendenti_expand', false)
        // DIPENDENTI - DOCS
        this.$set(this, 'dip_raggruppamento', {})
        this.$set(this, 'loading_dip_docs', false)
        this.$set(this, 'dip_docs', [])
        this.$set(this, 'dip_docs_pag', {
          currentPage: 1,
          pag_for: 10,
          nrPages: 0,
          nrItems: 0,
          counterWarning: 0
        })
      },
      setLoading: function (val) {
        this.$set(this, 'loading_dip', val)
      },
      openSearch: function () {
        this.$set(this, 'showSearchPanel', true)
        this.$emit('hideScroll')
        this.$emit('closeMessages')
      },
      closeSearch: function () {
        this.$emit('showScroll')
        this.$set(this, 'showSearchPanel', false)
      },
      changePageDip: function (page) {
        this.$set(this.dipendenti_pag, 'currentPage', page)
        this.ricercaDipendenti()
      },
      selectDipendente: function (dipendente) {
        this.$store.commit('set', {key: 'DIP_new', value: false})
        this.$store.commit('set', {key: 'DIP_Dipendente', value: dipendente})
        this.$router.push({name: 'DIPDipendente'})
      },
      newDipendente: function (dipendente) {
        this.$store.commit('set', {key: 'DIP_new', value: true})
        this.$store.commit('set', {key: 'DIP_Dipendente', value: {}})
        this.$router.push({name: 'DIPDipendente'})
      },
      cerca: function () {
        // this.$set(this, 'currentPage', 1)
        this.$set(this, 'country', this.$store.state.DOC_Ricerca.country)
        this.$set(this, 'codForn', this.$store.state.DOC_Ricerca.codForn)
        this.$set(this.ditta_ragg_pag, 'currentPage', 1)
        this.$set(this.dipendenti_pag, 'currentPage', 1)
        if (!this._inactive) {
          this.ricerca()
        }
      },
      sortChange: function ({column, prop, order}) {
        /*if (prop === 'dipendente') {
          if (order === 'ascending') {
            this.$set(this, 'ordine', '1A')
          } else if (order === 'descending') {
            this.$set(this, 'ordine', '1D')
          }
        } else if (prop === 'dataAssunzione') {
          if (order === 'ascending') {
             this.$set(this, 'ordine', '2A')
          } else if (order === 'descending') {
             this.$set(this, 'ordine', '2D')
          }
        } else if (prop === 'desMansione') {
          if (order === 'ascending') {
             this.$set(this, 'ordine', '3A')
          } else if (order === 'descending') {
             this.$set(this, 'ordine', '3D')
          }
        } else if (prop === 'tipoRapp') {
          if (order === 'ascending') {
             this.$set(this, 'ordine', '4A')
          } else if (order === 'descending') {
             this.$set(this, 'ordine', '4D')
          }
        }*/
        this.ricerca(true)
      },
      ricerca: function () {
        let ord = {
          codSoc: this.$store.state.DOC_Ricerca.codSoc,
          desSoc: this.$store.state.DOC_Ricerca.desSoc,
          codMag: this.$store.state.DOC_Ricerca.codMag,
          desMag: this.$store.state.DOC_Ricerca.desMag,
          numOrd: this.$store.state.DOC_Ricerca.numOrd,
          annoOrd: this.$store.state.DOC_Ricerca.annoOrd
        }
        this.$set(this, 'ordine',  ord)
        this.$set(this, 'tabActive',  this.$store.state.DOC_Ricerca.tabActive === undefined ? '0' : this.$store.state.DOC_Ricerca.tabActive)
        let form = this.$store.state.DOC_Ricerca
  
        // Flag per sapere se ho cambiato Stato e/o codForn
        let flagChange = false
  
        // Se il codForn salvato nel sessionStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (sessionStorage.getItem('ACCSTA_fornitore') !== form.codForn) {
          sessionStorage.setItem('ACCSTA_fornitore', form.codForn)
          flagChange = true
        }
  
        // Se lo Stato salvato nel localStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (localStorage.getItem('ACCSTA_country') !== form.country) {
          localStorage.setItem('ACCSTA_country', parseInt(form.country))
          flagChange = true
        }
        bus.$emit('Header_ChangeAdmin', form.country, 'ACCSTA')

        // Sono cambiati Stato e/o codForn
        if (flagChange) {
          bus.$emit('ACCSTA_ChangeCountryFromApp')
        }

        this.ricercaDocumentiFor()
        this.ricercaDipendenti()
        this.closeSearch()
      },
      /* ***** DITTA ***** */
      ricercaDocumentiFor: function (flagIfChangeSort) {
        this.$set(this, 'loading_ditta_ragg', true)
        if (flagIfChangeSort === true) {
          this.$set(this.ditta_ragg_pag, 'currentPage', 1)
        }
        let form = this.$store.state.DOC_Ricerca
        this.$http.get('documentirichiesti/raggdocfor', {
          params: {
            codLang: this.codLang,
            country: form.country,
            codForn: form.codForn,
            fornitore: form.fornitore,
            dipendente: form.dipendente,
            codSoc: form.codSoc,
            codMag: form.codMag,
            numOrd: form.numOrd,
            annoOrd: form.annoOrd,
            codDip: '',
            generici: form.generici,
            onlyActive: form.attivi,
            statoCat: form.statoCat,
            pag_action: (this.ditta_ragg_pag.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: (this.ditta_ragg_pag.currentPage - 1) * this.ditta_ragg_pag.pag_for + 1,
            pag_for: this.ditta_ragg_pag.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'ditta_ragg', response.body.data)

              if (this.ditta_ragg_pag.currentPage === 1) {
                this.$set(this.ditta_ragg_pag,'counterWarning',parseInt(response.body.attrib.nDocAlert))
                this.$set(this.ditta_ragg_pag,'nrItems',parseInt(response.body.attrib.size))
                let resto = parseInt(response.body.attrib.size) % this.ditta_ragg_pag.pag_for
                let aggiunta = resto > 0 ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.ditta_ragg_pag.pag_for) + aggiunta
                this.$set(this.ditta_ragg_pag, 'nrPages', nrPages)

                // Salvo la descrizione del fornitore
                this.$store.commit('setValue', {'form': 'DOC_Ricerca', 'field': 'desFornitore', 'value': response.body.attrib.desFornitore})
                this.$set(this, 'fornitore', response.body.attrib.fornitore)
                this.$set(this, 'desFornitore', response.body.attrib.desFornitore)
              }
            } else {
              this.$set(this, 'ditta_ragg', [])
              this.$set(this.ditta_ragg_pag, 'currentPage', 1)
              this.$set(this.ditta_ragg_pag, 'nrPages', 0)
              this.$set(this.ditta_ragg_pag, 'nrItems', 0)
              this.$set(this.ditta_ragg_pag, 'counterWarning', 0)
              this.$set(this, 'fornitore', '')
              this.$set(this, 'desFornitore', '')
            }
            this.$set(this, 'loading_ditta_ragg', false)
          })
      },
      changePageDittaRagg: function (page) {
        this.$set(this.ditta_ragg_pag, 'currentPage', page)
        this.ricercaDocumentiFor()
      },
      returnDittaRagg: function() {
        this.$set(this, 'ditta_vista', 'raggruppamenti')
        let ord = {
            codSoc: this.$store.state.DOC_Ricerca.codSoc,
            desSoc: this.$store.state.DOC_Ricerca.desSoc,
            codMag: this.$store.state.DOC_Ricerca.codMag,
            desMag: this.$store.state.DOC_Ricerca.desMag,
            numOrd: this.$store.state.DOC_Ricerca.numOrd,
            annoOrd: this.$store.state.DOC_Ricerca.annoOrd
        }
        this.$set(this, 'ordine',  ord)
        this.$set(this, 'ditta_docs', [])
      },
      changePageDittaDocs: function(page) {
        this.$set(this.ditta_docs_pag, 'currentPage', page)
        //this.$set(this, 'generici_Docs', {})
        this.getDittaDocs()
      },
      openTipologiaDitta: function(row) {
        this.$set(this, 'ditta_vista', 'docsGenerici')
        this.getDittaDocs(row)
      },
      getDittaDocs: function(row) {
        if (row !== undefined) {
          let ord = {
              codSoc: row.codSoc,
              desSoc: row.desSoc,
              codMag: row.codMag,
              desMag: row.desMag,
              numOrd: row.numOrd,
              annoOrd: row.annoOrd
          }
           this.$set(this, 'ordine',  ord)
        }
        this.$set(this, 'loading_ditta_docs', true)
        if (row !== undefined) {
          let doc = {
            'codTipo': row.codTipo,
            'desTipo': row.desTipo,
            'codSoc': row.codSoc,
            'desSoc': row.desSoc,
            'codMag': row.codMag,
            'desMag': row.desMag,
            'annoOrd': row.annoOrd,
            'numOrd': row.numOrd,
            'docRiva': row.docRiva,
            'presaVis': row.presaVis
          }
          this.$set(this, 'ditta_raggruppamento', doc)
        }
        this.$http.get('documentirichiesti/listadocfor', {
          params: {
            codLang: this.codLang,
            country: this.country,
            codForn: this.codForn,
            pag_action: this.ditta_docs_pag.currentPage > 1 ? 'NEXT' : 'BEGIN',
            pag_from: (this.ditta_docs_pag.currentPage - 1) * this.ditta_docs_pag.pag_for + 1,
            pag_for: this.ditta_docs_pag.pag_for,
            fornitore: this.fornitore,
            // codDip: '',
            codTipo: this.ditta_raggruppamento.codTipo,
            codSoc: this.ditta_raggruppamento.codSoc,
            codMag: this.ditta_raggruppamento.codMag,
            annoOrd: this.ditta_raggruppamento.annoOrd,
            numOrd: this.ditta_raggruppamento.numOrd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'ditta_docs', response.body.data)
              if (this.ditta_docs_pag.currentPage === 1) {
                this.$set(this.ditta_docs_pag, 'counterWarning', parseInt(response.body.attrib.nDocAlert))
                this.$set(this.ditta_docs_pag, 'nrItems', parseInt(response.body.attrib.size))
                let resto = parseInt(response.body.attrib.size) % this.ditta_docs_pag.pag_for
                let aggiunta = resto > 0 ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.ditta_docs_pag.pag_for) + aggiunta
                this.$set(this.ditta_docs_pag, 'nrPages', nrPages)
              }
            } else {
              this.$set(this, 'ditta_docs', [])
            }
            this.$set(this, 'loading_ditta_docs', false)
          })
      },
      uploadDocumentoDitta: function() {
        let documento = {
          codDip: '',
          codForn: this.codForn,
          codTipo: this.ditta_raggruppamento.codTipo,
          desTipo: this.ditta_raggruppamento.desTipo,
          codValidita: '',
          annoOrd: this.ditta_raggruppamento.annoOrd,
          numOrd: this.ditta_raggruppamento.numOrd,
          codSoc: this.ditta_raggruppamento.codSoc,
          desSoc: this.ditta_raggruppamento.desSoc,
          codMag: this.ditta_raggruppamento.codMag,
          desMag: this.ditta_raggruppamento.desMag,
          route: 'DOCElenco'
        }
        this.$store.commit('set', { key: 'GA_Documento', value: documento })
        this.$store.commit('setValue', {'form':'DOC_Ricerca', 'field':'tabActive', 'value':this.tabActive})
        this.$router.push({ name: 'DOCDocumento' })
      },
      /* ***** DIPENDENTI ***** */
      ricercaDipendenti: function (flagIfChangeSort) {
        this.$set(this, 'loading_dip', true)
        if (flagIfChangeSort === true) {
          this.$set(this.dipendenti_pag, 'currentPage', 1)
        }
        let form = this.$store.state.DOC_Ricerca
        this.$http.get('documentirichiesti/dipendentiacq', {
          params: {
            codLang: this.codLang,
            country: form.country,
            codForn: form.codForn,
            fornitore: form.fornitore,
            dipendente: form.dipendente,
            codSoc: form.codSoc,
            codMag: form.codMag,
            numOrd: form.numOrd,
            annoOrd: form.annoOrd,
            generici: form.generici,
            onlyActive: form.attivi,
            statoCat: form.statoCat,
            pag_action: (this.dipendenti_pag.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: (this.dipendenti_pag.currentPage - 1) * this.dipendenti_pag.pag_for + 1,
            pag_for: this.dipendenti_pag.pag_for,
            tipOrd: '1A'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'dipendenti', response.body.data)
              if (this.dipendenti_pag.currentPage === 1) {
                this.$set(this.dipendenti_pag,'counterWarning',parseInt(response.body.attrib.nDocAlert))
                this.$set(this.dipendenti_pag, 'nrItems', parseInt(response.body.attrib.size))

                let resto = parseInt(response.body.attrib.size) % this.dipendenti_pag.pag_for
                let aggiunta = (resto > 0) ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.dipendenti_pag.pag_for) + aggiunta
                this.$set(this.dipendenti_pag, 'nrPages', nrPages)

                // Salvo la descrizione del fornitore
               //  this.$store.commit('setValue', 'DOC_Ricerca' , 'desFornitore', response.body.attrib.desFornitore)
                this.$set(this.dipendenti_pag, 'fornitore', response.body.attrib.fornitore)
                this.$set(this.dipendenti_pag, 'desFornitore', response.body.attrib.desFornitore)
              }

            } else {
              this.$set(this, 'dipendenti', [])
              this.$set(this.dipendenti_pag, 'currentPage', 1)
              this.$set(this.dipendenti_pag,'counterWarning', 0)
              this.$set(this.dipendenti_pag, 'nrPages', 0)
              this.$set(this.dipendenti_pag, 'nrItems', 0)
              this.$set(this.dipendenti_pag, 'fornitore', '')
              this.$set(this.dipendenti_pag, 'desFornitore', '')
            }
            this.$set(this, 'loading_dip', false)
          })
      },
      goToDettaglioDip: function(row, expanded) {
        // Gestione Exapnd Dipendenti
        this.$set(this, 'loading_dipendenti_expand', true)
        this.$set(this, 'dipendenti_expand', [])
        let ifOpen = false
        expanded.forEach((dip, index) => {
          if (dip.codDip === row.codDip) {
            ifOpen = true
            expanded.splice(0, expanded.length)
            expanded.push(row)
          }
        })
        if (ifOpen === true) {
          setTimeout(() => {
            this.getRaggDocDip(row)
          }, 300)
        } else {
          this.$set(this, 'loading_dipendenti_expand', false)
        }
      },
      getRaggDocDip: function(dip) {
        let form = this.$store.state.DOC_Ricerca
        this.$set(this, 'codDip', dip.codDip)
        this.$set(this, 'desDip', dip.cognome + " " + dip.nome)
        this.$http.get('documentirichiesti/raggdocfor', {
          params: {
            codLang: this.codLang,
            country: form.country,
            codForn: form.codForn,
            fornitore: form.fornitore,
            dipendente: '',
            codSoc: form.codSoc,
            codMag: form.codMag,
            numOrd: form.numOrd,
            annoOrd: form.annoOrd,
            codDip: dip.codDip,
            generici: form.generici,
            onlyActive: form.attivi,
            statoCat: form.statoCat,
            pag_action: 'BEGIN', //(this.ditta_ragg_pag.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: 1, //(this.ditta_ragg_pag.currentPage - 1) * this.ditta_ragg_pag.pag_for + 1,
            pag_for: 100 //this.ditta_ragg_pag.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'dipendenti_expand', response.body.data)
            } else {
              if (response.body.msg[0].msgId !== '1001') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
            this.$set(this, 'loading_dipendenti_expand', false)
          })
      },
      openTipologiaDip: function(row) {
        this.$set(this, 'dip_vista', 'docsGenerici')
        this.getDipDocs(row)
      },
      getDipDocs: function(row) {
        this.$set(this, 'loading_dip_docs', true)
        if (row !== undefined) {
          let ord = {
              codSoc: row.codSoc,
              desSoc: row.desSoc,
              codMag: row.codMag,
              desMag: row.desMag,
              numOrd: row.numOrd,
              annoOrd: row.annoOrd
          }
          this.$set(this, 'ordine',  ord)
          let doc = {
            'codTipo': row.codTipo,
            'desTipo': row.desTipo,
            'codSoc': row.codSoc,
            'desSoc': row.desSoc,
            'codMag': row.codMag,
            'desMag': row.desMag,
            'annoOrd': row.annoOrd,
            'numOrd': row.numOrd
          }
          this.$set(this, 'dip_raggruppamento', doc)
        }
        this.$http.get('documentirichiesti/listadocdip', {
          params: {
            codLang: this.codLang,
            country: this.country,
            codForn: this.codForn,
            pag_action: this.dip_docs_pag.currentPage > 1 ? 'NEXT' : 'BEGIN',
            pag_from: (this.dip_docs_pag.currentPage - 1) * this.dip_docs_pag.pag_for + 1,
            pag_for: this.dip_docs_pag.pag_for,
            fornitore: this.fornitore,
            codDip: this.codDip,
            codTipo: this.dip_raggruppamento.codTipo,
            codSoc: this.dip_raggruppamento.codSoc,
            codMag: this.dip_raggruppamento.codMag,
            annoOrd: this.dip_raggruppamento.annoOrd,
            numOrd: this.dip_raggruppamento.numOrd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'dip_docs', response.body.data)
              if (this.dip_docs_pag.currentPage === 1) {
                //this.$set(this.dip_docs_pag, 'counterWarning', parseInt(response.body.attrib.nDocAlert))
                this.$set(this.dip_docs_pag, 'nrItems', parseInt(response.body.attrib.size))
                let resto = parseInt(response.body.attrib.size) % this.dip_docs_pag.pag_for
                let aggiunta = resto > 0 ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.dip_docs_pag.pag_for) + aggiunta
                this.$set(this.dip_docs_pag, 'nrPages', nrPages)
              }
            } else {
              this.$set(this, 'dip_docs', [])
            }
            this.$set(this, 'loading_dip_docs', false)
          })
      },
      returnDipRagg: function() {
        this.$set(this, 'dip_vista', 'raggruppamenti')
        let ord = {
            codSoc: this.$store.state.DOC_Ricerca.codSoc,
            desSoc: this.$store.state.DOC_Ricerca.desSoc,
            codMag: this.$store.state.DOC_Ricerca.codMag,
            desMag: this.$store.state.DOC_Ricerca.desMag,
            numOrd: this.$store.state.DOC_Ricerca.numOrd,
            annoOrd: this.$store.state.DOC_Ricerca.annoOrd
        }
        this.$set(this, 'ordine',  ord)
        this.$set(this, 'dip_docs', [])
      },
      uploadDocumentoDip: function() {
        let documento = {
          codDip: this.codDip,
          desDip: this.desDip,
          codForn: this.codForn,
          codTipo: this.dip_raggruppamento.codTipo,
          desTipo: this.dip_raggruppamento.desTipo,
          codValidita: '',
          annoOrd: this.dip_raggruppamento.annoOrd,
          numOrd: this.dip_raggruppamento.numOrd,
          codSoc: this.dip_raggruppamento.codSoc,
          desSoc: this.dip_raggruppamento.desSoc,
          codMag: this.dip_raggruppamento.codMag,
          desMag: this.dip_raggruppamento.desMag,
          route: 'DOCElenco'
        }
        this.$store.commit('set', { key: 'GA_Documento', value: documento })
        this.$store.commit('setValue', {'form':'DOC_Ricerca', 'field':'tabActive', 'value':this.tabActive})
        this.$router.push({ name: 'DOCDocumento' })
      },
      openDocumento: function(row, event, column) {
        let documento = {
          route: 'DOCElenco'
        }
        this.$store.commit('set', { key: 'GA_Documento', value: documento })
        this.$store.commit('setValue', {'form':'DOC_Ricerca', 'field':'tabActive', 'value':this.tabActive})
        this.$router.push({ name: 'DOCDocumento', params: { id: row.idDoc } })
      },
      getDocumento: function (doc) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAccessoStabilimenti + 'print/doc?idCli=RIV&idApp=FORDOCDIT' + '&keyDoc=' +  doc.idDoc + '&quality='+ process.env.qualityCM + '&token=' + response.body.wsToken)
              /*let url = (process.env.baseUrl + process.env.jaxrsFornAccStab + 'print/' + this.codLang + '/' +
                  this.country + '/docdipendente/' + doc.idDoc + '?quality='+ process.env.qualityCM +
                  '&token=' + response.body.wsToken)*/
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      deleteDocDitta: function(row) {
        this.$set(this, 'loading_ditta_docs', true)
        this.$http.delete('documentirichiesti/deletedoc', {
          params: {
            codLang: this.codLang,
            country: this.country,
            codForn: this.codForn,
            quality: process.env.qualityCM
          },
          body: {
            fornitore: this.fornitore,
            idDoc: row.idDoc,
            codDip: '',
            codTipo: row.codTipo,
            codSoc: row.codSoc,
            codMag: row.codMag,
            annoOrd: row.annoOrd,
            numOrd: row.numOrd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: this.$t('elencoDoc.deleteOK'),
                type: 'success',
                duration: process.env.duration
              })
              this.getDittaDocs()
              //this.getDocumenti(this.prodottoSelectedDoc.codProd)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg.msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loading_ditta_docs', false)
            }
          })
      },
      deleteDocDip: function(row) {
        this.$set(this, 'loading_dip_docs', true)
        this.$http.delete('documentirichiesti/deletedoc', {
          params: {
            codLang: this.codLang,
            country: this.country,
            codForn: this.codForn,
            quality: process.env.qualityCM
          },
          body: {
            fornitore: this.fornitore,
            idDoc: row.idDoc,
            codDip: this.codDip,
            codTipo: row.codTipo,
            codSoc: row.codSoc,
            codMag: row.codMag,
            annoOrd: row.annoOrd,
            numOrd: row.numOrd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: this.$t('elencoDoc.deleteOK'),
                type: 'success',
                duration: process.env.duration
              })
              this.getDipDocs()
              //this.getDocumenti(this.prodottoSelectedDoc.codProd)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg.msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loading_dip_docs', false)
            }
          })
      },
      tabClick: function(tab, event) {
        if (this.tabActive === '0') {
        } else if (this.tabActive === '1') {
          // this.getDocOrdini()
        }
      },
      getStatoIcon: function(stato) {
        switch (stato) {
          case '0':
            return 'riv-docNew_2'
          case '1':
            return 'riv-docWaiting_2'
          case '2':
            return 'riv-docAccepted_2'
          case '3':
            return 'riv-docRefused_2'
          case '4':
            return 'riv-docRefused_3'
          default:
            return ''
        }
      },
      getStabilimento: function () {
        if (this.ordine.desMag !== '') {
          return this.ordine.desMag
        } else  if (this.ordine.desSoc !== '') {
          return this.ordine.desSoc
        } else {
          return ''
        }
      },
      getOrdNum: function (numOrd) {
        if (numOrd === '000000' || numOrd === '') {
          return ''
        } else {
          numOrd = '000000' + numOrd
          return this.$i18n.t('elencoDoc.ordine', {num: numOrd.substr(numOrd.length - 6)})
        }
      },
      setClassRow: function({row, rowIndex}) {
        if (rowIndex === this.dipendenti_expand.length -1){
          return 'lastRow'
        } else {
          return ''
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../../assets/less/general.less";

  .elenco-documenti {
    .header-tab {
      height: 65px;
      text-align: center;
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0;
          margin-top: 12px;
          margin-left: 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
      .ordine {
        padding: 15px 0 0 0;
        .magazzino {
          height: 20px;
          .set-font(@size: 14px; @color: @greenRiva; @family: 'os-semibolditalic');
          text-transform: uppercase;
        }
        .numero {
          height: 40px;
          .set-font(@size: 16px; @color: @oroRiva; @family: 'os-semibolditalic');
          text-transform: uppercase;
        }
      }
      .fornitore {
        .set-font(@color: @greenRiva; @size: 16px; @family: 'os-semibolditalic');
        text-align: right;
        margin-top: 12px;
        right: 10px;
        span {
              display: block;
        }
        .fa-icon {
          margin-top: 3px;
          line-height: 30px;
          color: @rossoRiva
        }
      }
    }
    .custom-tabs {
      min-height: 310px;
      &.el-tabs {
        .el-tabs__header {
          .counter-nuovi {
            .el-badge {
              .el-badge__content {
                height: 18px;
                width: 18px;
                top: 9px;
                right: -3px;
                padding: 0;
                line-height: 16px;
                .set-font(@color: @white, @size: 10px);
                letter-spacing: 0;
                background-color: @oroRiva;
              }
            }
          }
          .el-tabs__item {
            width: 250px;
            font-size: 14px;
            text-transform: capitalize;
          }
        }
      }
    }
    
    .custom-table {
      .el-table__header {
        thead {
          th {
            .cell {
              font-size: 13px;
            }
          }
        }
      }
      .el-table__body-wrapper {
        min-height: 170px;
        .cell {
          .scaduto {
            .set-font(@color: @rossoRiva; @family: "os-semibold");
          }
        }
      }
      .action {
        .fa-icon {
          color: @rossoRiva;
        }
      }
      .icon-center {
        .fa-icon {
          text-align: center !important;
          float: none !important;
        }
      }
      td {
        padding-top: 5px;
        padding-bottom: 5px;
        &.el-table__expanded-cell {
          padding: 0px 0px 0px 70px !important;
          .el-table {
            .el-table__header-wrapper {
              border-bottom: 1px solid #ccc;
              .el-table__header {
                th {
                  .cell {
                    .set-font(@family: "os-lightitalic", @size: 12px);
                  }
                }
              }
            }
            .el-table__body-wrapper {
              min-height: auto;
              .el-table__body {
                .lastRow {
                  td {
                    border-bottom: none;
                  }
                }
                td {
                  padding: 3px 0;
                  .cell {
                    .set-font(
                      @family: "os-regular",
                      @size: 11px,
                      @color: @textTable
                    );
                    line-height: 20px !important;
                  }
                }
              }
            }
          }
        }
        &.el-table__expanded-cell:hover {
          background-color: @white;
        }
      }
    }

    .table-doc.table-doc {
      min-height: 407px;
      // margin-top: 5px;
      .el-table__header {
        thead {
          th {
            // padding: 0 !important;
            .cell {
              .el-popover__reference {
                padding-top: 0;
                line-height: 16px;
              }
            }
          }
        }
      }
      .fa-icon {
        //color: @rossoRiva;
        float: right;
      }
      .el-table__body-wrapper {
        .tipoDoc {
          background-color: #eff6f6;
          text-align: left;
          .cell {
            .set-font(@color: @greenRiva, @family: 'os-semibolditalic', @size: 13px) !important;
          }
        }
      }
    }

    .return-tab {
      flex: auto;
      padding-bottom: 15px;
      .fa-icon {
        margin-top: 5px;
        line-height: 30px;
        float: left;
      }
      span {
        float: left;
        text-transform: uppercase;
        line-height: 30px;
        height: 30px;
        padding-left: 15px;
        .set-font(@color: @greenRiva; @size: 16px; @family: "os-semibolditalic");
      }
      .capitalize {
        text-transform: capitalize;
        padding-left: 5px;
      }
    }
    .add {
      margin-top: 4px;
      line-height: 30px;
      color: #bb515c;
    }
    
    .custom-tabs.el-tabs .el-tabs__header {
      z-index: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/DocumentiRichiesti/ElencoDocumenti.vue